<template>
  <v-container fluid d-flex justify-center class='footer'>
    <span>&copy; 2018 Mastodon Meetup at Tokyo</span>
  </v-container>
</template>

<script>
export default {
  name: 'eventfooter',
  props: {},
}
</script>

<style scoped>
  .footer {
    color: white;
    text-align: center;
    padding: 0px;
    font-size: 0.8rem;
  }
</style>
